


















import { Component, Prop, Vue } from 'vue-property-decorator';
import GtLoading from '@/components/svg/GtLoading.vue';

@Component<GtButton>({
  components: {
    GtLoading,
  },
})
export default class GtButton extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean
  @Prop({ type: String, default: 'default' }) readonly type!: string

  get styleClass() {
    return `gt__btn--${this.type}`;
  }
}
